import { Button } from '@heidi/design-system/button';
import { TypographyCaption } from '@heidi/design-system/typography';
import { useTranslations, type TranslationKey } from '@heidi/runtime/i18n';
import { Trash2, X } from 'lucide-react';

interface ChatSelectionBarProps {
  selectedCount: number;
  onDelete: () => void;
  onClear: () => void;
}

export const ChatSelectionBar = ({ selectedCount, onDelete, onClear }: ChatSelectionBarProps) => {
  const { t } = useTranslations();

  if (selectedCount === 0) return null;

  return (
    <div className="flex items-center justify-between px-2 py-1">
      <div className="flex items-center gap-1">
        <TypographyCaption className="text-text-secondary">
          {t('deleteChatModal.nSelected' as TranslationKey, { count: selectedCount })}
        </TypographyCaption>
        <Button variant="ghost" size="xs" iconOnly onClick={onClear} aria-label="Clear selection">
          <X size={12} />
        </Button>
      </div>
      <Button variant="destructive" size="xs" onClick={onDelete}>
        <Trash2 size={12} />
        {t('deleteChatModal.delete' as TranslationKey)}
      </Button>
    </div>
  );
};
